<mc-form [formGroup]="sftpForm" [submitFn]="submitFn" [successMessage]="successMessage" [errorMessage]="errorMessage" [deleteFn]="connector ? deleteFn : null" [deleteConfirmDialogData]="deleteConfirmDialogData"
  [deleteSuccessMessage]="deleteSuccessMessage" (success)="success.emit($event)" (cancel)="cancel.emit($event)">
  <ng-template mcFormBody>

    <p class="mc-form-heading">Settings</p>

    <mat-form-field class="mc-form-field" mcColor="secondary">
      <mat-label>Name</mat-label>
      <input matInput formControlName="sftpName" placeholder="Name" type="text">
      <mat-error>
        <mc-form-control-error-message [form]="sftpForm" controlName="sftpName" type="mc_connector_name"></mc-form-control-error-message>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="mc-form-field" mcColor="secondary">
      <mat-label>URL</mat-label>
      <input matInput formControlName="sftpUrl" placeholder="URL" type="text">
      <mat-error>
        <mc-form-control-error-message [form]="sftpForm" controlName="sftpUrl" type="mc_url"></mc-form-control-error-message>
      </mat-error>
    </mat-form-field>

    <p class="mc-form-heading">Validation</p>

    <mat-form-field class="mc-form-field" mcColor="secondary">
      <mat-label>Type</mat-label>
      <mat-select formControlName="sftpValidationType">
        <mat-option *ngFor="let type of validationTypes" [value]="type.value">
          {{ type.text }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="validationType === SftpServerValidation.PublicKey">
      <mat-form-field class="mc-form-field" mcColor="secondary">
        <mat-label>Public Key</mat-label>
        <textarea matInput formControlName="sftpPublicKey" placeholder="Public Key" rows="3" [ngClass]="{ 'mc-input-masked': managedControls.sftpPublicKey.valueHidden }"></textarea>
        <mat-icon fontSet="project-titan" matIconSuffix fontIcon="icon-eye-open" (click)="toggleValueHidden('sftpPublicKey')"></mat-icon>
        <mat-error>
          <mc-form-control-error-message [form]="sftpForm" controlName="sftpPublicKey" type="mc_connectors_validation_public_key"></mc-form-control-error-message>
        </mat-error>
      </mat-form-field>
    </ng-container>

    <p class="mc-form-heading">Authentication</p>

    <mat-form-field class="mc-form-field" mcColor="secondary">
      <mat-label>Type</mat-label>
      <mat-select formControlName="sftpAuthenticationType">
        <mat-option *ngFor="let type of authenticationTypes" [value]="type.value">
          {{ type.text }}
        </mat-option>
      </mat-select>
      <mat-error>
        <mc-form-control-error-message [form]="sftpForm" controlName="sftpAuthenticationType" type="mc_connectors_auth_type"></mc-form-control-error-message>
      </mat-error>
    </mat-form-field>

    <mat-form-field class="mc-form-field" mcColor="secondary">
      <mat-label>Username</mat-label>
      <input matInput formControlName="sftpUsername" placeholder="Username" type="text">
      <mat-error>
        <mc-form-control-error-message [form]="sftpForm" controlName="sftpUsername" type="mc_connectors_username"></mc-form-control-error-message>
      </mat-error>
    </mat-form-field>

    <ng-container *ngIf="authType === SftpAuthentication.Password">
      <mat-form-field *ngIf="!managedControls.sftpPassword.controlHidden" class="mc-form-field" mcColor="secondary">
        <mat-label>Password</mat-label>
        <input #sftpPassword class="mc-form-password-input-edge-eye-hidden" autocomplete="new-password" matInput formControlName="sftpPassword" placeholder="Password"
          [type]="managedControls.sftpPassword.valueHidden ? 'password' : 'text'">
        <mat-icon fontSet="project-titan" matIconSuffix fontIcon="icon-eye-open" (click)="toggleValueHidden('sftpPassword')"></mat-icon>
        <mat-error>
          <mc-form-control-error-message [form]="sftpForm" controlName="sftpPassword" type="mc_connectors_password"></mc-form-control-error-message>
        </mat-error>
      </mat-form-field>

      <button *ngIf="managedControls.sftpPassword.controlHidden" mat-stroked-button (click)="showSecretControl('sftpPassword')">Change Password</button>
    </ng-container>

    <ng-container *ngIf="authType === SftpAuthentication.PrivateKey">
      <mat-form-field *ngIf="!managedControls.sftpPrivateKey.controlHidden" class="mc-form-field" mcColor="secondary">
        <mat-label>Key</mat-label>
        <textarea #sftpPrivateKey matInput formControlName="sftpPrivateKey" placeholder="Key" rows="3" [ngClass]="{ 'mc-input-masked': managedControls.sftpPrivateKey.valueHidden }"></textarea>
        <mat-icon fontSet="project-titan" matIconSuffix fontIcon="icon-eye-open" (click)="toggleValueHidden('sftpPrivateKey')"></mat-icon>
        <mat-error>
          <mc-form-control-error-message [form]="sftpForm" controlName="sftpPrivateKey" type="mc_connectors_key"></mc-form-control-error-message>
        </mat-error>
      </mat-form-field>

      <button *ngIf="managedControls.sftpPrivateKey.controlHidden" mat-stroked-button (click)="showSecretControl('sftpPrivateKey')">Change Key</button>

      <mat-form-field *ngIf="!managedControls.sftpPrivateKeyPassword.controlHidden" class="mc-form-field" mcColor="secondary">
        <mat-label>Key Password</mat-label>
        <input #sftpPrivateKeyPassword class="mc-form-password-input-edge-eye-hidden" autocomplete="new-password" matInput formControlName="sftpPrivateKeyPassword" placeholder="Key Password"
          [type]="managedControls.sftpPrivateKeyPassword.valueHidden ? 'password' : 'text'">
        <mat-icon fontSet="project-titan" matIconSuffix fontIcon="icon-eye-open" (click)="toggleValueHidden('sftpPrivateKeyPassword')"></mat-icon>
        <mat-error>
          <mc-form-control-error-message [form]="sftpForm" controlName="sftpPrivateKeyPassword" type="mc_connectors_key_password"></mc-form-control-error-message>
        </mat-error>
      </mat-form-field>

      <button *ngIf="managedControls.sftpPrivateKeyPassword.controlHidden" [ngClass]="{ 'mc-sftp-form-change-key-password-button': managedControls.sftpPrivateKey.controlHidden }"
        (click)="showSecretControl('sftpPrivateKeyPassword')" mat-stroked-button>
        Change Key Password
      </button>
    </ng-container>
  </ng-template>
</mc-form>